import { gql } from '@apollo/client'

export const CurrencyDetailsFragment = gql`
  fragment CurrencyDetails on Currency {
    name
    code
    isBaseCurrency
  }
`
